import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import { useCustomSnackbar } from '../../hooks/useCustomSneakbar';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { generateAxiosInstanceTeacher } from '../../hooks/useAuthorizedRequestForTeacher';
import { useNavigate } from 'react-router-dom';

const ListOfAssignedExam = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    let sectionMasterId = localStorage.getItem("sectionMasterId")

    const initialFormState = {
        section_id: sectionMasterId,
        // instituteMasterId: instituteMasterId,
        start_date: '',
        end_date: '',
        divisionId: '',
        year: '',
        gradeId: ''
    }

    const [gradeList, setGradeList] = useState([])
    const [divisionList, setDivisionList] = useState([])
    const [yearList, setYearList] = useState([])
    const [importStudentData, setImportStudentData] = useState(initialFormState)
    const [importStudentList, setImportStudentList] = useState([])
    const [page, setPage] = useState(1)
    const [total, setTotal] = useState(300)
    const [refreshList, setRefreshList] = useState(false)
    const [limit, setLimit] = useState(100)
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getGradeList()
        getYearList()
    }, []);

    // const renderContent = () => {
    //     const items = [];
    //     for (let i = 1; i <= Math.ceil(total / limit); i++) {
    //         i >= page && i <= page + 3 && items.push(
    //             <div className={i === page ? 'circle-btn selected' : 'circle-btn'}>{i}</div>
    //         );
    //     }
    //     return items;
    // }

    useEffect(() => {
        if (importStudentData.year !== '') {
            let apiUrl = '/assigned-exams?';
            if (sectionMasterId !== '') {
                apiUrl += `section_id=${sectionMasterId}&`;
            }
            if (importStudentData.start_date !== '') {
                apiUrl += `start_date=${importStudentData.start_date}&`;
            }

            if (importStudentData.divisionId !== '') {
                apiUrl += `division_id=${importStudentData.divisionId}&`;
            }

            if (importStudentData.end_date !== '') {
                apiUrl += `end_date=${importStudentData.end_date}&`;
            }

            apiUrl = apiUrl.replace(/&$/, '');
            authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
                .then(response => {
                    setImportStudentList(response.data.data);
                    setTotal(response.data.length)
                })
                .catch(error => {
                    setImportStudentList(error?.response?.data.result);
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }
    }, [importStudentData]);

    const getGradeList = () => {
        const apiUrlForSyllabus = `/get-institute-grade?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrlForSyllabus)
            .then(response => {
                setGradeList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getYearList = () => {
        const apiUrlForSyllabus = `/active-academic-years`;
        authorizedAxios && authorizedAxios.get(apiUrlForSyllabus)
            .then(response => {
                setYearList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e) => {
        setImportStudentData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    const handleGradeChange = (e) => {
        setImportStudentData((prevData) => {
            return {
                ...prevData,
                divisionId: '',
                [e.target.name]: e.target.value
            }
        })
        const apiUrlForSyllabus = `/grade-wise-division?instituteMasterId=${instituteMasterId}&instituteGradeMasterId=${e.target.value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrlForSyllabus)
            .then(response => {
                setDivisionList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    return (
        <>
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>List of Assigned Exam</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-users-line"></i> List of Assigned Exam</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Year :</label>
                                                    <select class="form-select" aria-label="Default select example" name='year' onChange={handleInputChange} value={importStudentData.year}>
                                                        <option selected value={''} disabled>Select Year</option>
                                                        {
                                                            yearList?.map((year) => {
                                                                return <option value={year.id}>{year.yearName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class :</label>
                                                    <select class="form-select" aria-label="Default select example" name='gradeId' onChange={handleGradeChange} value={importStudentData.gradeId}>
                                                        <option selected value={''} disabled>Select Class</option>
                                                        {
                                                            gradeList?.map((grade) => {
                                                                return <option value={grade.id}>{grade.gradeName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Division :</label>
                                                    <select class="form-select" aria-label="Default select example" name='divisionId' onChange={handleInputChange} value={importStudentData.divisionId}>
                                                        <option selected value={''} disabled>Select Division</option>
                                                        {
                                                            divisionList?.map((division) => {
                                                                return <option value={division.id}>{division.divisionName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Start Date :</label>
                                                    <input type='date' className="form-control" name='start_date' onChange={handleInputChange} value={importStudentData.start_date} />
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select End  Date :</label>
                                                    <input type='date' className="form-control" name='end_date' onChange={handleInputChange} value={importStudentData.end_date} />
                                                </div>
                                            </div>

                                            <div className="row">
                                                {/* <div className='custom-pagintation'>
                                                    <div className='left-info'>
                                                        <h5>Results</h5>
                                                        <select onChange={(e) => setPage(e.target.value)} className='pageNo'>
                                                            <option value={10}>10</option>
                                                            <option selected value={100}>100</option>
                                                            <option value={200}>200</option>
                                                        </select>
                                                    </div>
                                                    <button className='btn btn-outline-danger delete_icon' style={{ marginRight: "20px" }} onClick={() => { setImportStudentList([]); setImportStudentData(initialFormState) }}>Reset</button>
                                                    <div className='right-info'>
                                                        <button className='nextPrevBtn first' disabled={page <= 1} onClick={() => setPage(page - 1)}>
                                                            <i class="fa fa-chevron-left" aria-hidden="true"></i>
                                                        </button>
                                                        {renderContent()}
                                                        <button className='nextPrevBtn last' disabled={total / limit < page} onClick={() => setPage(page + 1)}>
                                                            <i class="fa fa-chevron-right" aria-hidden="true"></i>
                                                        </button>
                                                    </div>
                                                </div> */}

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">Division</th>
                                                                        <th scope="col">Exam Master</th>
                                                                        <th scope="col">Class ID </th>
                                                                        <th scope="col">Exam ID</th>
                                                                        <th scope="col">Exam Total Time</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        importStudentList?.length > 0 ?
                                                                            importStudentList?.map((std, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{index + 1}</th>
                                                                                        <td>{std?.ExamAssignDivisions.map(item => item.InstituteDivisionMaster?.divisionName)}</td>
                                                                                        <td>{std?.ExamMaster?.exam_name}</td>
                                                                                        <td>{std?.class_id}</td>
                                                                                        <td>{std?.exam_id}</td>
                                                                                        <td>{std?.exam_total_time}</td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Students Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default ListOfAssignedExam
